'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { TextCTA } from '@lichtblick/photon/atoms/text-cta/text-cta';
import { useTracker } from '@lichtblick/tracker';
export const SecondaryNavigationCTA = ({ href, onClick, text, tracking })=>{
    const { trackCustomEvent } = useTracker();
    return /*#__PURE__*/ _jsx(TextCTA, {
        as: "a",
        href: href,
        onClick: (event)=>{
            trackCustomEvent(tracking);
            onClick?.(event);
        },
        tabIndex: href ? undefined : 0,
        children: text
    });
};

//# sourceMappingURL=SecondaryNavigationCTA.js.map